<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-19 20:35:43
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-17 19:02:09
-->
<template>
  <div class="role-info-container">
    <div class="info-hearder flex-row">
      <img src="../../../common/assets/images/role-default.png" alt="" />
      <div class="base-info flex-column">
        <span class="title">{{ roleInfo?.roleName ?? '' }} </span>
        <span>{{ roleInfo?.remark ?? '' }}</span>
      </div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="role-auth-tab">
      <el-tab-pane label="功能权限" name="first"></el-tab-pane>
      <el-tab-pane label="数据权限" name="second"></el-tab-pane>
      <div class="role-perm-content x-tree-container" v-show="activeName === 'first'">
        <el-tree
          :data="functionTreeOptions"
          show-checkbox
          ref="functionScopeTree"
          node-key="value"
          :highlight-current="true"
          :expand-on-click-node="false"
          default-expand-all
          :props="defaultProps"
          @check="handleCheckChange"
          :render-content="renderContent"
        >
        </el-tree>
      </div>
      <div class="role-data-content flex-column" v-if="activeName === 'second'">
        <div class="form-item flex-column">
          <x-filter-item :label="'数据范围'">
            <x-radio-group :list-data="dataOptions" v-model="selectVal" />
          </x-filter-item>
        </div>
        <!---自定义选项内容展示 --->
      </div>
    </el-tabs>
  </div>
</template>
<script lang="jsx">
  import { cloneDeep } from '@package/utils'
  import { apiGetMenuTree } from '@main/modules/auth/api'
  // import { EnumApiCode } from '../../../../../../globalEnum.js'

  export default {
    name: 'RoleAuthInfo',
    props: {
      mode: {
        // 当前是否可选择权限
        type: String,
        default: 'edit'
      },
      roleInfo: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        activeName: 'first',
        selectVal: '',
        dataOptions: [
          {
            label: '本人',
            value: '1'
          },
          {
            label: '本部门',
            value: '2'
          },
          {
            label: '本部门及下属子部门',
            value: '3'
          },
          {
            label: '全部',
            value: '4'
          },
          {
            label: '自定义',
            value: '5'
          }
        ],
        functionTreeOptions: [],
        functionKeys: [],
        defaultProps: {
          label: 'label',
          children: 'children'
        },
        dataTreeOptions: [],
        dataKeys: [],
        expandKeys: [],
        deptData: [],
        renderContent(h, { node, data }) {
          // 树节点的内容区的渲染 Function
          let classname = ''
          let iconClass = ''
          // 由于项目中有三级菜单也有四级级菜单，就要在此做出判断
          if (`${data.menuType}` === '3') {
            classname = 'flex-node'
          } else {
            iconClass = 'iconfont icon-erjicaidan'
          }

          return (
            <div class={classname}>
              <i class={iconClass} />
              {node.label}
            </div>
          )
        }
      }
    },
    watch: {
      roleInfo: {
        handler(val) {
          if (val) {
            this.selectVal = val?.disType ?? ''
            this.$nextTick(() => {
              this.functionKeys = cloneDeep(val.menus)
              if (this.$refs.functionScopeTree) {
                const times = setTimeout(() => {
                  this.handleSetClass()
                  clearTimeout(times)
                })
              }
              this.dataKeys = cloneDeep(val.scopes)
              this.handleSetCheck()
            })
          }
        },
        immediate: true,
        deep: true
      },
      mode: {
        handler(val) {
          if (val === 'view') {
            // TODO：等待后端接口，详情获取角色的菜单树，
            // this.setDisabled(this.functionTreeOptions)
            // this.setDisabled(this.deptData)
          }
        }
      }
    },
    mounted() {
      this.loadFuncitonTree()
    },
    methods: {
      async loadFuncitonTree() {
        const { data } = await apiGetMenuTree()
        this.functionTreeOptions = data?.length
          ? JSON.parse(
              JSON.stringify(data)
                .replace(/menuName/g, 'label')
                .replace(/id/g, 'value')
            )
          : []
        this.$nextTick(() => {
          this.handleSetCheck()
          const times = setTimeout(() => {
            this.handleSetClass()
            clearTimeout(times)
          })
        })
      },
      handleClick(tab) {
        this.activeName = tab.name
        // if (this.activeName === 'second') {
        // }
      },
      handleSetCheck() {
        if (this.$refs?.functionScopeTree) {
          let menuIds = this.functionKeys ? JSON.parse(JSON.stringify(this.functionKeys)) : []
          const result = menuIds && menuIds.length ? this.filterTreeData(menuIds, this.functionTreeOptions) : []
          this.$refs.functionScopeTree.setCheckedKeys(result)
        }
      },
      handleCheckChange() {
        const result = this.$refs.functionScopeTree.getCheckedNodes(false, true)
        this.functionKeys = result.map((v) => v.value)
        this.handleSetClass()
      },
      clearRoleAuth() {
        this.activeName = 'first'
        this.dataKeys = []
        this.functionKeys = []
        this.selectVal = '1'
      },
      handleSetClass() {
        const btnNodes = document.getElementsByClassName('flex-node')
        for (let i = 0; i < btnNodes.length; i++) {
          if (btnNodes[i].parentNode.parentNode.classList) {
            btnNodes[i].parentNode.parentNode.classList.add('btn-node')
          }
          btnNodes[i].parentNode.onmouseover = function () {
            this.style.backgroundColor = '#fff'
          }
          this.$forceUpdate()
          const childrenNodes = btnNodes[i].parentNode.parentNode.parentNode.children
          let isNum = 0
          for (let j = 0; j < childrenNodes.length; j++) {
            if (childrenNodes[j].classList.value.indexOf('btn-node') !== -1) {
              childrenNodes[j].classList.remove('menu-node')
              isNum++
            } else {
              childrenNodes[j].classList.add('menu-node')
            }
            if (isNum > 1) {
              childrenNodes[j].classList.add('no-line')
            }
          }
        }
      },
      setDisabled(treeData) {
        treeData.forEach((item) => {
          this.$set(item, 'disabled', true)
          if (item.children) {
            this.setDisabled(item.children)
          }
        })
      },
      filterTreeData(checkedKeys, menus) {
        menus.forEach((item) => {
          if (checkedKeys.includes(item.value) && item.children.length) {
            checkedKeys.splice(checkedKeys.indexOf(item.value), 1)
          }
          if (item.children.length) {
            checkedKeys = this.filterTreeData(checkedKeys, item.children)
          }
        })
        return checkedKeys
      }
    }
  }
</script>
<style lang="scss" scoped>
  .role-info-container {
    display: flex;
    flex-direction: column;
    height: 100%;

    .info-hearder.flex-row {
      padding: 20px;

      img {
        width: 105px;
        border-radius: 50%;
      }

      .base-info {
        justify-content: center;
        padding-left: 20px;

        span {
          color: #333;

          &.title {
            font-size: 20px;
            font-weight: bold;
            line-height: 43px;
          }

          .el-tag--mini {
            line-height: 19px;
            height: 20px;
            margin-left: 8px;
            padding: 0 5px;
            color: #409eff;
          }
        }
      }
    }

    .role-data-content {
      color: #333;
    }

    .role-perm-content {
      height: 100%;

      .el-tree {
        overflow-y: auto;
        height: 100%;
      }
    }
  }
</style>
<style lang="scss">
  @import '../../../common/assets/style/tree';

  .role-auth-tab.el-tabs.el-tabs--top {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: calc(100% - 145px);
    padding: 0 20px;
  }

  .role-auth-tab.el-tabs.el-tabs--top .el-tabs__content {
    flex: 1;
  }

  .role-auth-tab .el-tabs__nav-wrap {
    padding-left: 15px;
  }

  .role-perm-content .el-tree-node.is-expanded > .el-tree-node__children {
    /* display: flex; */
  }

  .role-perm-content .el-tree-node.is-expanded.is-focusable > .el-tree-node__content {
    // padding: 5px 0;
  }
</style>
